<template>
  <div :class="{ 'is-invalid': invalid }">
    <v-select
      v-if="!isLoadingSchool"
      :options="filteredSchools"
      label="value"
      v-model="selectedSchool"
      placeholder="พิมพ์ชื่อโรงเรียนที่ต้องการค้นหา"
      :clearable="false"
      @input="onSelect"
    >
      <template #search="{ attributes, events }">
        <input
          class="vs__search"
          v-bind="attributes"
          v-on="events"
          v-model="searchSchool"
        />
      </template>
      <template #selected-option="option">
        {{ truncateMiddle(option.value, 45) }}
      </template>
    </v-select>
    <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
  </div>
</template>

<script>
// Searchable school dropdown backed by the shared Thai school list (same source as
// StudentCountBySchoolReport.vue). v-model is the school name string.
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const SCHOOL_LIST_URL =
  "https://s1.coursesquare.co/data/thailand-school/thai-school-list.json";

// Shared across every SchoolSelect instance so the ~57k-entry list is downloaded once.
// Frozen so Vue doesn't make each entry reactive.
let schoolListPromise = null;

function loadSchoolList() {
  if (!schoolListPromise) {
    schoolListPromise = fetch(SCHOOL_LIST_URL)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) =>
        Object.freeze([...new Map(data.map((item) => [item.id, item])).values()])
      )
      .catch((error) => {
        schoolListPromise = null; // allow a retry on the next mount
        throw error;
      });
  }
  return schoolListPromise;
}

export default {
  components: { vSelect },
  props: {
    value: { type: String, default: null },
    invalid: { type: Boolean, default: false },
  },
  data() {
    return {
      searchSchool: "",
      selectedSchool: null,
      schoolList: [],
      isLoadingSchool: false,
    };
  },
  computed: {
    filteredSchools() {
      if (!this.searchSchool) {
        return this.schoolList.slice(0, 50);
      }

      const searchLower = this.searchSchool.toLowerCase();
      const filtered = this.schoolList.filter(
        (option) =>
          option.value && option.value.toLowerCase().includes(searchLower),
      );

      return filtered.slice(0, 50);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectedSchool = newVal ? { value: newVal } : null;
      },
    },
  },
  mounted() {
    this.fetchSchoolData();
  },
  methods: {
    async fetchSchoolData() {
      try {
        this.isLoadingSchool = true;
        this.schoolList = await loadSchoolList();
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการดึงข้อมูล:", error);
      } finally {
        this.isLoadingSchool = false;
      }
    },
    truncateMiddle(text, startChars = 4) {
      if (!text) return "";
      const textStr = String(text);
      if (textStr.length <= startChars) {
        return textStr;
      }
      const start = textStr.substring(0, startChars);
      return `${start}...`;
    },
    onSelect(option) {
      this.$emit("input", option ? option.value : "");
    },
  },
};
</script>

<style scoped>
.is-invalid ::v-deep .vs__dropdown-toggle {
  border-color: #dc3545;
}
</style>
